/* 自動生成ファイル: scripts/build-theme-assets.js が assets/ から作成。直接編集しないこと。 */
/* ============================================================
   スロパチパーツナビ — カテゴリ単一管理ソース
   ----------------------------------------------------------------
   このファイル 1 つにすべてのカテゴリ／グループ／アイコンを集約。
   各 HTML は data-render="..." 属性を置くだけで、起動時に自動描画。

   2 階層構造：
     ・MAIN_CATEGORIES   (3) … トップページの大型カード／ナビ直接リンク
     ・SUB_GROUPS (5) + SUB_CATEGORIES (10) … 「オプション・周辺」メガメニュー

   ★ ハーネスは「ユニット商品ページの必要オプション」として推奨
     独立カテゴリ表示はしない（HIDDEN_CATEGORIES）

   Shopify 移植時の対応：
     - MAIN_CATEGORIES → 個別 Collection
     - SUB_GROUPS / SUB_CATEGORIES → ネスト Linklist
   ============================================================ */

(function () {
  "use strict";

  // ----- カテゴリ/接続タイプのリンク URL を取得 -----
  // products.js の getCategoryLinkUrl があれば使用：該当商品 1 件のみなら詳細ページ直リンク
  // products.js 未ロードなら従来通り collection.html?cat=... へフォールバック
  function catUrl(cat, conn) {
    if (window.SLOPACHI_PRODUCTS && typeof window.SLOPACHI_PRODUCTS.getCategoryLinkUrl === "function") {
      return window.SLOPACHI_PRODUCTS.getCategoryLinkUrl(cat, conn);
    }
    return "collection.html?cat=" + cat + (conn ? "&conn=" + conn : "");
  }

  // ============================================================
  // 1. メインカテゴリ（3 大商材）— 顧客の最初の自己認識「自分の機械タイプ」と直結
  //    各カテゴリは下位階層として「接続タイプ」を持つ場合がある
  //    （スマスロ:4 / スマパチ:2 / コイン不要機:なし）
  // ============================================================
  const MAIN_CATEGORIES = [
    {
      handle: "smaslo-unit",
      name: "スマスロユニット",
      sublabel: "スマートパチスロ機をお持ちの方",
      description: "スマスロ（スマート遊技機）を家庭で動かすためのユニット", // 家庭向けの商品のみ（2026-10-19 ユーザー確認）
      icon: "unit",
      enabled: true,
      connectionTypes: [
        { handle: "main-no-data",   connection: "メイン基板接続タイプ", dataOutput: "データ出力なし", desc: "機種のメイン基板に接続するタイプ。\n【メリット】メイン基板のコネクターで接続するためコンパクト。クレジットがなくなると自動でクレジットが入ります。\n【デメリット】コネクターの形状が違う機種には使い回しできません。" },
        { handle: "main-with-data", connection: "メイン基板接続タイプ", dataOutput: "データ出力あり", desc: "機種のメイン基板に接続するタイプ。\n【メリット】メイン基板のコネクターで接続するためコンパクト。クレジットがなくなると自動でクレジットが入ります。\n【デメリット】コネクターの形状が違う機種には使い回しできません。" },
        // 2026-10-14 一旦非表示（ユーザー指示）: { handle: "bet-no-data",    connection: "BETボタン接続タイプ",      dataOutput: "データ出力なし", desc: "機種のBETボタンに接続するタイプ。\n【メリット】メイン基板のコネクターで接続するためコンパクト。BETボタンで好きなときにクレジットを入れられ、切り替えでクレジットがなくなったときの自動投入にもできます。\n【デメリット】コネクターの形状が違う機種には使い回しできません。" },
        // 2026-10-14 一旦非表示（ユーザー指示）: { handle: "bet-with-data",  connection: "BETボタン接続タイプ",      dataOutput: "データ出力あり", desc: "機種のBETボタンに接続するタイプ。\n【メリット】メイン基板のコネクターで接続するためコンパクト。BETボタンで好きなときにクレジットを入れられ、切り替えでクレジットがなくなったときの自動投入にもできます。\n【デメリット】コネクターの形状が違う機種には使い回しできません。" },
        { handle: "usb-no-data",    connection: "D-SUB接続タイプ",           dataOutput: "データ出力なし", desc: "機種のD-SUBに接続するタイプ。\n【メリット】すべての機種に使い回しできます。\n【デメリット】ほかのユニットより少し価格が高めです。" },
        { handle: "usb-with-data",  connection: "D-SUB接続タイプ",           dataOutput: "データ出力あり", desc: "機種のD-SUBに接続するタイプ。\n【メリット】すべての機種に使い回しできます。\n【デメリット】ほかのユニットより少し価格が高めです。" },
        { handle: "box",            connection: "D-SUB接続 / ボックスタイプ",            dataOutput: "データ出力あり",     desc: "機種のD-SUBに接続し、ボックスを手元に置いて操作するタイプ。\n【メリット】手元のボックスに付いているボタンを押してクレジットを入れられます。切り替えで、クレジットがなくなったときの自動投入にもできます。接続はD-SUB接続タイプと同じなので、1つあればどの機種にも使い回しできます。\n【デメリット】ほかのユニットより価格が高めです。" },
        { handle: "smakey",         connection: "D-SUB接続 / スマキー",                  dataOutput: "データ出力なし（動作チェック用・電池式）", desc: "ボタン電池で動くタイプ。\n【メリット】電源を用意しなくても使えるので、動作チェックのときなどに気軽に使えます。本体の簡易的な動作チェックに向いていて、倉庫などで機械の動作チェックをする方に人気の商品です。\n【デメリット】ボタン電池式のため、長時間使い続けることはできません。動作チェックを主な用途とした商品です。" },
      ],
    },
    {
      handle: "smapachi-unit",
      name: "スマパチユニット",
      sublabel: "スマートパチンコ機をお持ちの方",
      description: "スマパチ（スマート遊技機）を家庭で動かすためのユニット",
      icon: "pachi",
      enabled: true,
      connectionTypes: [
        { handle: "main-no-data",   connection: "メイン基板接続タイプ", dataOutput: "データ出力なし", desc: "機種のメイン基板に接続するタイプ。\n【メリット】メイン基板のコネクターで接続するためコンパクト。クレジットがなくなると自動でクレジットが入ります。\n【デメリット】コネクターの形状が違う機種には使い回しできません。" },
        { handle: "main-with-data", connection: "メイン基板接続タイプ", dataOutput: "データ出力あり", desc: "機種のメイン基板に接続するタイプ。\n【メリット】メイン基板のコネクターで接続するためコンパクト。クレジットがなくなると自動でクレジットが入ります。\n【デメリット】コネクターの形状が違う機種には使い回しできません。" },
        { handle: "usb-no-data",    connection: "D-SUB接続タイプ",           dataOutput: "データ出力なし", desc: "機種のD-SUBに接続するタイプ。\n【メリット】すべての機種に使い回しできます。\n【デメリット】ほかのユニットより少し価格が高めです。" },
        { handle: "usb-with-data",  connection: "D-SUB接続タイプ",           dataOutput: "データ出力あり", desc: "機種のD-SUBに接続するタイプ。\n【メリット】すべての機種に使い回しできます。\n【デメリット】ほかのユニットより少し価格が高めです。" },
        { handle: "box",            connection: "D-SUB接続 / ボックスタイプ",            dataOutput: "データ出力あり",     desc: "機種のD-SUBに接続し、ボックスを手元に置いて操作するタイプ。\n【メリット】手元のボックスに付いているボタンを押してクレジットを入れられます。切り替えで、クレジットがなくなったときの自動投入にもできます。接続はD-SUB接続タイプと同じなので、1つあればどの機種にも使い回しできます。\n【デメリット】ほかのユニットより価格が高めです。" },
        { handle: "smakey",         connection: "D-SUB接続 / スマキー",                  dataOutput: "データ出力なし（動作チェック用・電池式）", desc: "ボタン電池で動くタイプ。\n【メリット】電源を用意しなくても使えるので、動作チェックのときなどに気軽に使えます。本体の簡易的な動作チェックに向いていて、倉庫などで機械の動作チェックをする方に人気の商品です。\n【デメリット】ボタン電池式のため、長時間使い続けることはできません。動作チェックを主な用途とした商品です。" },
      ],
    },
    {
      handle: "coinless",
      name: "コイン不要機",
      sublabel: "通常パチスロ機をお持ちの方",
      description: "通常パチスロ機（4号機・5号機・6号機）向け、コインを入れずに自宅で遊技できる装置",
      note: "※ パチンコ機には対応していません",
      megaMenuBody: "コインを入れずに自宅で遊技できる装置です。通常パチスロ機（4号機・5号機・6号機など）にご使用いただけます。",
      icon: "no-coin",
      enabled: true,
      // 接続タイプの分岐なし（シンプル設計）
    },
    // 2026-10-13 ユーザー決定：旧「対応ユニット 準備中」（standard-pinball-coming-soon・LINE 誘導のみ）を
    // 商品カテゴリ「CRアダプター」に変更（CR アダプター 3 商品を掲載）
    {
      handle: "cr-adapter",
      name: "CRアダプター",
      sublabel: "通常パチンコ機をお持ちの方",
      description: "パチンコ台裏のCRユニット接続コネクタに差し込むだけで、玉貸し・ハンドル操作ができるアダプター",
      megaMenuBody: "通常パチンコ機（CR機・P機）を、CRユニットにつないだ時とほぼ同じ状態で動かせるアダプターです。台裏のCRユニット接続コネクタに差し込むだけで、玉貸しボタンやハンドルの操作ができます。",
      icon: "pachi",
      enabled: true,
    },
  ];

  // ============================================================
  // 2. サブグループ（オプション・周辺）
  // ============================================================
  const SUB_GROUPS = [
    { handle: "wiring",      name: "配線・電源",   desc: "イヤホンコンバーター・ボリューム" },
    { handle: "fixture",     name: "設置・什器",   desc: "スタンド・玉上げリフター・カギ" },
    { handle: "operation",   name: "操作補助",     desc: "オートプレイ・コントローラー" },
    { handle: "peripheral",  name: "周辺機器",     desc: "データカウンター" },
    { handle: "maintenance", name: "メンテナンス", desc: "清掃用品・工具" },
  ];

  // ============================================================
  // 3. サブカテゴリ（10 種）
  //    enabled: true/false で表示制御
  //    featured: true で「あわせて選ばれるオプション」セクション上部に表示
  //
  //    ★ ローンチ (2026-05-07)：公開中は trans / auto-play のみ
  //      他 8 件は販売状況をみて段階的に enabled:true に切替予定
  // ============================================================
  const SUB_CATEGORIES = [
    /* ---- 配線・電源 ---- */
    { handle: "converter",    name: "イヤホンコンバーター",          group: "wiring",      icon: "earphone",    desc: "実機の音をイヤホンへ", enabled: true, featured: true },
    { handle: "trans",        name: "トランス",                      group: "wiring",      icon: "transformer", desc: "電源変圧器",                enabled: false }, // TR-100 を非公開にしたため（2026-10-19 ユーザー指示。電気用品安全法の確認待ち）
    { handle: "volume",       name: "ボリューム",                    group: "wiring",      icon: "knob",        desc: "音量・調整つまみ",          enabled: false },

    /* ---- 設置・什器 ---- */
    { handle: "cabinet",      name: "キャビネット・スタンド",        group: "fixture",     icon: "cabinet",     desc: "機械を載せる土台",          enabled: false, featured: true },
    { handle: "lifter",       name: "玉上げリフター",                group: "fixture",     icon: "lifter",      desc: "下皿の玉を自動で上皿へ。遊技を中断せず連続プレイできます。", enabled: false, featured: true },
    { handle: "key",          name: "カギ",                          group: "fixture",     icon: "key",         desc: "ドアキー・各種鍵",          enabled: false },

    /* ---- 操作補助 ---- */
    { handle: "nav-auto",     name: "ナビオートユニット",            group: "operation",   icon: "auto",        desc: "押し順制御付き 機種専用",   enabled: true,
      sublabel: "押し順自動制御",
      tagline: "ボーナス・AT 中の押し順をユニットが自動制御。機種専用設計で、対応機種一覧をご確認のうえお選びください。" },
    { handle: "press-auto",   name: "順押しオートユニット",          group: "operation",   icon: "auto",        desc: "単純押下 / 筐体共通対応",   enabled: true,
      sublabel: "シンプル仕様",
      tagline: "ボタンを単純に上から順に押下するシンプル仕様。筐体共通で対応するため、手頃な価格でご利用いただけます。" },
    { handle: "pachi-auto",   name: "パチンコオートコントローラー",  group: "operation",   icon: "controller",  desc: "パチンコ用自動操作機器",    enabled: false },

    /* ---- 周辺機器 ---- */
    { handle: "data-counter", name: "データカウンター",              group: "peripheral",  icon: "counter",     desc: "出玉・回転数表示器",        enabled: false },

    /* ---- メンテナンス ---- */
    { handle: "maintenance",  name: "メンテナンス用品",              group: "maintenance", icon: "wrench",      desc: "工具・潤滑剤・清掃用品",    enabled: false },
  ];

  // ============================================================
  // 4. 隠しカテゴリ（独立 UI 表示なし、商品ページから自動推奨）
  //    現状は空。
  //    （旧：ハーネス単品販売を検討していたが、USB接続タイプで使い回し
  //     可能なため販売方針を取り下げ。CSV からも撤去済）
  // ============================================================
  const HIDDEN_CATEGORIES = [];

  // ============================================================
  // 5. SVG アイコン定義（Hexa-Line / 1.5px stroke / no fill）
  // ============================================================
  const ICONS = {
    "unit":        '<rect x="3" y="6" width="18" height="12" rx="1.5"/><path d="M7 10v4M12 10v4M17 10v4"/>',
    "pachi":       '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/>',
    "no-coin":     '<circle cx="12" cy="12" r="9"/><path d="M5 5l14 14"/>',
    "auto":        '<path d="M5 4v16M11 4v16M17 4v16"/><path d="M19 12l3-3-3-3M2 12l3-3-3-3"/>',
    "controller":  '<rect x="4" y="6" width="16" height="14" rx="2"/><circle cx="9" cy="13" r="1.6"/><circle cx="15" cy="13" r="1.6"/><path d="M9 4v3M15 4v3"/>',
    "cable":       '<path d="M5 4v6c0 4 4 4 4 8v2"/><path d="M19 4v6c0 4-4 4-4 8v2"/><circle cx="5" cy="3" r="1.4"/><circle cx="19" cy="3" r="1.4"/><rect x="7" y="20" width="4" height="2" rx="0.5"/><rect x="13" y="20" width="4" height="2" rx="0.5"/>',
    "wave":        '<path d="M3 18l5-7 4 5 4-3 5 4"/><path d="M3 18h18"/>',
    "earphone":    '<path d="M4 13v-1a8 8 0 0 1 16 0v1"/><rect x="3" y="13" width="4" height="7" rx="1"/><rect x="17" y="13" width="4" height="7" rx="1"/>',
    "transformer": '<rect x="4" y="6" width="16" height="12" rx="1"/><path d="M9 10v4M12 10v4M15 10v4"/><path d="M2 12h2M20 12h2"/>',
    "knob":        '<circle cx="12" cy="12" r="8"/><path d="M12 5v3"/><circle cx="12" cy="12" r="2"/>',
    "lifter":      '<path d="M4 19h16"/><path d="M7 14h10"/><path d="M12 14V4M9 7l3-3 3 3"/><path d="M9 19v-5M15 19v-5"/>',
    "cabinet":     '<rect x="5" y="3" width="14" height="18" rx="1"/><path d="M5 9h14"/><circle cx="9" cy="6" r="0.7"/><path d="M9 13v5"/>',
    "key":         '<circle cx="8" cy="12" r="4"/><path d="M12 12h8M16 12v3M19 12v2"/>',
    "counter":     '<rect x="3" y="6" width="18" height="12" rx="1"/><path d="M7 10v4M11 10v4M15 10v4"/>',
    "wrench":      '<path d="M14 7l3-3 3 3-3 3-2-2"/><path d="M14 7l-9 9 3 3 9-9"/>',
  };

  // ============================================================
  // 6. ヘルパー
  // ============================================================
  function enabledMain() {
    return MAIN_CATEGORIES.filter(function (c) { return c.enabled; });
  }
  function enabledSub() {
    return SUB_CATEGORIES.filter(function (c) { return c.enabled; });
  }
  function getSubGroupsWithCategories() {
    return SUB_GROUPS
      .map(function (g) {
        return Object.assign({}, g, {
          categories: enabledSub().filter(function (c) { return c.group === g.handle; }),
        });
      })
      .filter(function (g) { return g.categories.length > 0; });
  }
  function getFeaturedSub(limit) {
    return enabledSub().filter(function (c) { return c.featured; }).slice(0, limit || 4);
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (m) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[m];
    });
  }
  function svgIcon(key, size) {
    var s = size || 24;
    return '<svg class="icon" width="' + s + '" height="' + s +
      '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
      (ICONS[key] || "") + "</svg>";
  }
  function currentFile() {
    var p = (window.location.pathname || "").split("/").pop();
    return (p || "index.html").toLowerCase();
  }

  // ============================================================
  // 7. レンダラー：site-nav
  //    [スマスロ][スマパチ][コイン不要機][オプション▾][機種名から探す]
  // ============================================================
  function renderSiteNav(target) {
    var params = new URLSearchParams(window.location.search);
    var currentCat = params.get("cat") || window.SPN_COLLECTION_HANDLE || "";
    var file = currentFile();

    var html = "";

    // メイン 3 カテゴリ（メガメニュー付き）
    // - 接続タイプを持つカテゴリ（スマスロ・スマパチ）：接続タイプカード表示
    // - 接続タイプ無し（コイン不要機）：教育的な説明文表示
    enabledMain().forEach(function (c) {
      var active = currentCat === c.handle;
      var hasConn = c.connectionTypes && c.connectionTypes.length > 0;
      var widthClass = hasConn ? " has-conn-" + c.connectionTypes.length : " no-conn";

      html += '<div class="nav-group nav-group-main' + (active ? " is-active" : "") + '">';
      html += '<a href="' + catUrl(c.handle) + '" class="nav-group-trigger">';
      html += escapeHtml(c.name);
      html += '<svg class="caret" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
      html += "</a>";

      html += '<div class="megamenu main-megamenu' + widthClass + '" role="menu">';

      // ヘッダー部
      html += '<div class="mm-head">';
      html += '<h4>' + escapeHtml(c.name) + '</h4>';
      if (c.sublabel) html += '<p>' + escapeHtml(c.sublabel) + '</p>';
      html += '</div>';

      if (hasConn) {
        // 接続タイプカード
        html += '<div class="mm-section">';
        html += '<div class="mm-section-head">ユニットタイプから選ぶ（全 ' + c.connectionTypes.length + ' タイプ）</div>';
        html += '<div class="mm-conn-grid count-' + c.connectionTypes.length + '">';
        c.connectionTypes.forEach(function (ct, idx) {
          html += '<a class="mm-conn-card" href="' + catUrl(c.handle, ct.handle) + '">';
          html += '<span class="num">' + (idx + 1) + '</span>';
          html += '<div class="name">' + escapeHtml(ct.connection) + '</div>';
          html += '<div class="data">' + escapeHtml(ct.dataOutput) + '</div>';
          html += '</a>';
        });
        html += '</div></div>';
      } else {
        // 教育的な説明（コイン不要機など）
        html += '<div class="mm-info">';
        var bodyText = c.megaMenuBody || c.description || "";
        if (bodyText) html += '<p>' + escapeHtml(bodyText) + '</p>';
        if (c.note) html += '<p class="note">' + escapeHtml(c.note) + '</p>';
        html += '</div>';
      }

      // フッター（全商品 + LINE 退避路）
      html += '<div class="mm-footer">';
      html += '<a href="/collections/' + c.handle + '" class="mm-link">→ ' + escapeHtml(c.name) + ' すべての商品を見る</a>';
      // 「機種名で探す」はユニット（接続タイプのあるカテゴリ）専用の検索のため、
      // コイン不要機・CRアダプターなどには出さない（2026-10-14 ユーザー指摘で削除）
      html += '<a href="#" class="mm-line" data-line="category" data-category-name="' + escapeHtml(c.name) + '">わからない場合は LINE で相談</a>';
      html += '</div>';

      html += '</div>'; // /megamenu
      html += '</div>'; // /nav-group
    });

    // オプション・周辺 メガメニュー
    var subGroups = getSubGroupsWithCategories();
    var subActive = enabledSub().some(function (c) { return c.handle === currentCat; });
    if (subGroups.length > 0) {
      html += '<div class="nav-group nav-group-options' + (subActive ? " is-active" : "") + '">';
      // スマホはメガメニューを出さないので "#" だと押しても何も起きない → カテゴリ一覧へ（2026-10-15）
      html += '<a href="/collections" class="nav-group-trigger">';
      html += "オプション・周辺";
      html += '<svg class="caret" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
      html += "</a>";
      html += '<div class="megamenu options-megamenu" role="menu">';
      html += '<div class="mm-grid">';
      subGroups.forEach(function (g) {
        html += '<div class="mm-section">';
        html += '<div class="mm-section-head">' + escapeHtml(g.name) + "</div>";
        g.categories.forEach(function (c) {
          html += '<a href="' + catUrl(c.handle) + '" class="megamenu-item" role="menuitem">';
          html += '<span class="mm-icon">' + svgIcon(c.icon, 16) + "</span>";
          html += '<span class="mm-text"><span class="mm-name">' + escapeHtml(c.name) + "</span>";
          if (c.desc) html += '<span class="mm-desc">' + escapeHtml(c.desc) + "</span>";
          html += "</span></a>";
        });
        html += "</div>";
      });
      // ドアキー・設定キー（カテゴリではなく「機種名から鍵を探す」ページへ。2026-11-03 ユーザー指示）
      html += '<div class="mm-section"><div class="mm-section-head">実機の鍵</div>';
      html += '<a href="/pages/key-finder" class="megamenu-item" role="menuitem">';
      html += '<span class="mm-icon">' + svgIcon("key", 16) + "</span>";
      html += '<span class="mm-text"><span class="mm-name">ドアキー・設定キー</span><span class="mm-desc">機種名から対応する鍵を探す</span></span></a>';
      html += "</div>";
      html += "</div></div></div>";
    }

    // 機種名から探す
    html += '<a href="/search"' + (file === "search.html" ? ' class="is-active"' : "") +
      ">機種名から探す</a>";

    target.innerHTML = html;
  }

  // ============================================================
  // 8. レンダラー：main-categories（3 大商材の大型カード）
  //    トップページのヒーロー直下、最重要セクション
  //    接続タイプを持つカテゴリは「X タイプから選べる」ヒントを表示
  // ============================================================
  function renderMainCategories(target) {
    var html = '<div class="main-category-grid">';
    enabledMain().forEach(function (c) {
      var isComingSoon = c.comingSoon === true;
      var cardClasses = "main-category-card variant-" + c.handle + (isComingSoon ? " is-coming-soon" : "");
      // 準備中カードは LINE 相談へ、それ以外は collection ページへ
      var href = isComingSoon ? "#"
                              : catUrl(c.handle);
      var dataAttrs = isComingSoon
        ? ' data-line="category" data-category-handle="' + c.handle + '" data-category-name="' + escapeHtml(c.sublabel) + '"'
        : "";
      html += '<a class="' + cardClasses + '" href="' + href + '"' + dataAttrs + '>';
      if (isComingSoon) {
        html += '<span class="coming-soon-badge">準備中</span>';
      }
      html += '<span class="icon-frame">' + svgIcon(c.icon, 32) + "</span>";
      html += '<div class="text">';
      html += '<div class="sublabel">' + escapeHtml(c.sublabel) + "</div>";
      html += "<h3>" + escapeHtml(c.name) + "</h3>";
      html += '<p class="desc">' + escapeHtml(c.description || "") + "</p>";
      if (c.note) {
        html += '<p class="note">' + escapeHtml(c.note) + '</p>';
      }
      // 接続タイプヒント
      if (c.connectionTypes && c.connectionTypes.length > 0) {
        html += '<div class="hint">全 ' + c.connectionTypes.length + ' タイプから選べる</div>';
      }
      html += "</div>";
      if (isComingSoon) {
        html += '<span class="cta">LINE で相談する ';
        html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.5 2 2 5.7 2 10.2c0 2.7 1.6 5.1 4.1 6.6l-.5 2c-.1.4.3.7.6.5 0 0 2.6-1.6 3.4-2.1.8.1 1.5.2 2.4.2 5.5 0 10-3.7 10-8.2S17.5 2 12 2z"/></svg>';
      } else {
        html += '<span class="cta">商品を見る ';
        html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
      }
      html += "</span>";
      html += "</a>";
    });
    html += "</div>";
    target.innerHTML = html;
  }

  // ============================================================
  // 9. レンダラー：connection-types（接続タイプ選択カード）
  //    URL の cat パラメータからメインカテゴリを判定し、
  //    そのカテゴリが持つ接続タイプ一覧をカードで表示。
  //    cat が無いとき、または接続タイプが未定義のときは何も描画しない。
  // ============================================================
  function renderConnectionTypes(target) {
    var params = new URLSearchParams(window.location.search);
    // 接続タイプ表示は、collection.html?cat=... 経由の遷移を想定。
    // 静的デモ閲覧時もスマスロユニットを既定で表示できるようフォールバック。
    var cat = params.get("cat") || window.SPN_COLLECTION_HANDLE || "";
    var main = MAIN_CATEGORIES.find(function (m) { return m.handle === cat; });
    if (!main || !main.enabled || !main.connectionTypes || main.connectionTypes.length === 0) {
      target.innerHTML = "";
      return;
    }

    var connFilter = params.get("conn");
    var n = main.connectionTypes.length;

    var html = '<div class="connection-types-section">';
    html += '<div class="connection-types-head">';
    html += '<h3>どのタイプですか？（全 ' + n + ' タイプ）</h3>';
    html += '<p>お好みに合うタイプを選んでください。' +
            '<span class="hint-text">わからない場合は ' +
            '<a href="#" data-line="category" data-category-name="' + escapeHtml(main.name) + '">LINE で機種名を送ってください →</a>' +
            '</span></p>';
    html += '</div>';
    html += '<div class="connection-types-grid count-' + n + '">';

    main.connectionTypes.forEach(function (ct, idx) {
      var active = connFilter === ct.handle;
      html += '<a class="connection-type-card' + (active ? " is-active" : "") +
              '" href="' + catUrl(cat, ct.handle) + '">';
      html += '<span class="num">' + (idx + 1) + '</span>';
      html += '<div class="conn-name">' + escapeHtml(ct.connection) + '</div>';
      html += '<div class="conn-data">' + escapeHtml(ct.dataOutput) + '</div>';
      if (ct.desc) html += '<div class="conn-desc">' + escapeHtml(ct.desc) + '</div>';
      html += '</a>';
    });
    html += '</div></div>';

    target.innerHTML = html;
  }

  // ============================================================
  // 10. レンダラー：autoplay-cross-promo
  //     スマスロユニット／コイン不要機 のコレクションページ上部に
  //     「プラスαで便利に：オートプレイユニット」帯を表示。
  //     SUB_CATEGORIES の crossPromoFor を見て該当カテゴリでのみ描画。
  //     スマパチユニット では描画しない（要件通り）。
  // ============================================================
  function renderAutoplayCrossPromo(target) {
    var params = new URLSearchParams(window.location.search);
    var cat = params.get("cat") || window.SPN_COLLECTION_HANDLE || "";

    // クロスプロモ対象のサブカテゴリを抽出（現状はオートプレイユニットのみ）
    var promos = enabledSub().filter(function (c) {
      return Array.isArray(c.crossPromoFor) && c.crossPromoFor.indexOf(cat) !== -1;
    });

    if (promos.length === 0) {
      target.innerHTML = "";
      return;
    }

    var html = "";
    promos.forEach(function (c) {
      var url = c.productPageUrl || catUrl(c.handle);
      html += '<a class="cross-promo-strip" href="' + url + '">';
      html += '<span class="cp-icon" aria-hidden="true">+α</span>';
      html += '<div class="cp-text">';
      html += '<div class="cp-eyebrow">プラスαで便利に</div>';
      html += '<h4>' + escapeHtml(c.name) + '</h4>';
      html += '<p>' + escapeHtml(c.tagline || c.desc || "") + '</p>';
      html += '</div>';
      html += '<span class="cp-cta">';
      html += '詳細';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
      html += '</span>';
      html += '</a>';
    });
    target.innerHTML = html;
  }

  // ============================================================
  // 11. レンダラー：sub-categories（オプション・周辺、グループごとにセクション）
  // ============================================================
  function renderSubCategories(target) {
    var groups = getSubGroupsWithCategories();
    var html = "";
    groups.forEach(function (g) {
      html += '<div class="category-group" id="group-' + g.handle + '">';
      html += '<div class="category-group-head">';
      html += "<h3>" + escapeHtml(g.name) + "</h3>";
      if (g.desc) html += "<p>" + escapeHtml(g.desc) + "</p>";
      html += "</div>";
      html += '<div class="category-grid">';
      g.categories.forEach(function (c) {
        html += '<a class="category-card" href="' + catUrl(c.handle) + '">';
        html += '<span class="icon-frame">' + svgIcon(c.icon, 28) + "</span>";
        html += "<div>";
        html += '<div class="name">' + escapeHtml(c.name) + "</div>";
        if (c.desc) html += '<div class="desc">' + escapeHtml(c.desc) + "</div>";
        html += "</div>";
        html += '<span class="arrow">›</span>';
        html += "</a>";
      });
      html += "</div></div>";
    });
    // ドアキー・設定キー（スマホではメガメニューが出ないので、ここにも入口を置く。2026-11-03 Codex 指摘）
    html += '<div class="category-group" id="group-key">';
    html += '<div class="category-group-head"><h3>実機の鍵</h3><p>お持ちの実機に合う鍵を機種名から探せます</p></div>';
    html += '<div class="category-grid"><a class="category-card" href="/pages/key-finder">';
    html += '<span class="icon-frame">' + svgIcon("key", 28) + "</span>";
    html += '<div><div class="name">ドアキー・設定キー</div><div class="desc">機種名から対応する鍵を探す</div></div>';
    html += '<span class="arrow">›</span></a></div></div>';
    target.innerHTML = html;
  }

  // ============================================================
  // 12. レンダラー：footer-categories（メイン 3 + 注目サブ最大 1）
  // ============================================================
  function renderFooterCategories(target) {
    var html = "";
    enabledMain().forEach(function (c) {
      html += '<li><a href="' + catUrl(c.handle) + '">' + escapeHtml(c.name) + "</a></li>";
    });
    html += '<li><a href="/#categories">オプション・周辺機器</a></li>';
    target.innerHTML = html;
  }

  // ============================================================
  // 13. マウント
  // ============================================================
  // 静的 HTML に書かれた [data-cat-link="<cat>"] / [data-conn-link="<conn>"] 属性付き
  // <a> タグの href を catUrl() で書き換える。商品 1 件ならその詳細ページへ直リンク。
  function applyCatLinks() {
    document.querySelectorAll("a[data-cat-link]").forEach(function (a) {
      var cat = a.getAttribute("data-cat-link");
      var conn = a.getAttribute("data-conn-link") || "";
      if (cat) a.setAttribute("href", catUrl(cat, conn));
    });
  }

  function mountAll() {
    document.querySelectorAll('[data-render="site-nav"]').forEach(renderSiteNav);
    document.querySelectorAll('[data-render="main-categories"]').forEach(renderMainCategories);
    document.querySelectorAll('[data-render="connection-types"]').forEach(renderConnectionTypes);
    document.querySelectorAll('[data-render="autoplay-cross-promo"]').forEach(renderAutoplayCrossPromo);
    document.querySelectorAll('[data-render="sub-categories"]').forEach(renderSubCategories);
    // 後方互換：旧 category-grid マウントポイントは sub-categories と同等扱い
    document.querySelectorAll('[data-render="category-grid"]').forEach(renderSubCategories);
    document.querySelectorAll('[data-render="footer-categories"]').forEach(renderFooterCategories);
    applyCatLinks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountAll);
  } else {
    mountAll();
  }

  // デバッグ用
  window.SLOPACHI_CATEGORIES = {
    main: MAIN_CATEGORIES,
    subGroups: SUB_GROUPS,
    sub: SUB_CATEGORIES,
    hidden: HIDDEN_CATEGORIES,
    icons: ICONS,
    enabledMain: enabledMain,
    enabledSub: enabledSub,
    grouped: getSubGroupsWithCategories,
    featured: getFeaturedSub,
  };
})();
